<template>
  <b-container>
      <b-form-group
      :label="$t('tracking.nonAttendanceReason.sequenceNumber')"
      label-for="sequenceNumber"
    >
      <base-input-integer
        id="sequencNumber"
        :placeholder="$t('tracking.nonAttendanceReason.sequenceNumber')"
        :value.sync="model.sequenceNumber"
        :readonly="readonly"
      >
      </base-input-integer>
    </b-form-group>
    <b-form-group
      :label="$t('tracking.nonAttendanceReason.displayName')"
      label-for="displayName"
    >
      <b-form-input
        id="descripton"
        type="text"
        :placeholder="$t('tracking.nonAttendanceReason.displayName')"
        v-model="model.displayName"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['DisplayName']">
        {{ modelstate["DisplayName"][0] }}
      </span>
    </b-form-group>
  </b-container>
</template>
<script>
import BaseInputInteger from "@/components_rms/base/BaseInputInteger.vue";
export default {
  name: "DisapprovedReasonData",
  directives: {},
  components: {
    BaseInputInteger,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},

  watch: {
    model() {
      this.$forceUpdate();
    },
  },
};
</script>
